import ThiSensorApi from "@/api/thi-sensor-api";
import i18n from "@/plugins/i18n";

export default {
  name: "CreateThiSensorModal",

  props: { reload: Function },
  data() {
    return {
      isLoading: false,
      deveui: null,
      name: null,
      description: null,
      errors: {},
      serverError: null
    };
  },
  methods: {
    validate() {
      this.errors = {};
      if (!this.deveui) {
        this.errors.deveui = i18n.t("thiSensorDetails.errors.deveuiRequired");
        return false;
      }
      return true;
    },
    async create() {
      this.serverError = null;
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await ThiSensorApi.create({
          deveui: this.deveui,
          name: this.name,
          description: this.description
        });

        if (response && response.status === 200) {
          if (this.reload) {
            this.reload();
          }
          this.close();
        } else if (response && response.status === 404) {
          this.serverError = i18n.t("thiSensorDetails.errors.notFound");
        } else if (response && response.status === 409) {
          this.serverError = i18n.t("thiSensorDetails.errors.alreadyAssigned");
        } else {
          this.serverError = (response && response.data) || i18n.t("thiSensorDetails.errors.generic");
        }
      } catch (e) {
        this.serverError = i18n.t("thiSensorDetails.errors.generic");
      } finally {
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/create-thi-sensor/create-thi-sensor-modal.js